import React from "react"
import PropTypes from "prop-types"
import { CloseOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"

const EquipmentTable = ({ equipment, onAction, actionType, emptyMessage, canEdit, loading }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableHeader}>
        <div className={styles.equipmentColumn}>
          <Text className={styles.headerText}>{t("booking.equipment.equipment")}</Text>
        </div>
        <div className={styles.assetNumberColumn}>
          <Text className={styles.headerText}>{t("booking.equipment.asset_number")}</Text>
        </div>
        <div className={styles.maxGuestsColumn}>
          <Text className={styles.headerText}>{t("booking.equipment.max_guests")}</Text>
        </div>
        <div className={styles.categoryColumn}>
          <Text className={styles.headerText}>{t("booking.equipment.category")}</Text>
        </div>
        {canEdit && (
          <div className={styles.actionColumn}>
            <Text className={styles.headerText}>{t(`booking.equipment.${actionType}`)}</Text>
          </div>
        )}
      </div>

      {equipment.length === 0 ? (
        <div className={styles.centeredRow}>
          <Text>{emptyMessage}</Text>
        </div>
      ) : (
        equipment.map((item) => (
          <div key={item.id} className={styles.tableRow}>
            <div className={styles.equipmentColumn}>
              <Text>{item.name}</Text>
            </div>
            <div className={styles.assetNumberColumn}>
              <Text>{item.assetNumber}</Text>
            </div>
            <div className={styles.maxGuestsColumn}>
              <Text>{item.maxGuests ?? "-"}</Text>
            </div>
            <div className={styles.categoryColumn}>
              <Text>{item.category}</Text>
            </div>
            {canEdit && (
              <div className={styles.actionColumn}>
                <button
                  className={actionType === "unassign" ? styles.unassignButton : styles.assignButton}
                  onClick={() => onAction(item)}
                  disabled={loading}
                >
                  {loading ? <LoadingOutlined /> : actionType === "unassign" ? <CloseOutlined /> : <PlusOutlined />}
                </button>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  )
}

EquipmentTable.propTypes = {
  equipment: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      assetNumber: PropTypes.string.isRequired,
      maxGuests: PropTypes.number,
      category: PropTypes.string.isRequired
    })
  ).isRequired,
  onAction: PropTypes.func.isRequired,
  actionType: PropTypes.oneOf(["assign", "unassign"]).isRequired,
  emptyMessage: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
  loading: PropTypes.bool
}

export default EquipmentTable
